import { gql } from '@apollo/client';
import COMMENT_REACTION_FIELDS_FRAGMENT from './CommentReactionFields';
import USER_AVATAR_FRAGMENT from './UserAvatar';

const COMMENT_FIELDS_FRAGMENT = gql`
  fragment CommentFields on Comment {
    id
    content
    author {
      id
      name
      ...UserAvatar
    }
    insertedAt
    reactions {
      ...CommentReactionFields
    }
  }
  ${USER_AVATAR_FRAGMENT}
  ${COMMENT_REACTION_FIELDS_FRAGMENT}
`;

export default COMMENT_FIELDS_FRAGMENT;
